import { useTranslation } from 'react-i18next';

import { FullScreenNotice } from './FullScreenNotice';
import { RotateCwIcon } from '../../../components';

/**
 * 주변 소음 안내 — 전체화면 (시안 `884:9858`).
 *
 * 측정 화면 위의 모달이 아니라 **화면 전환**이다. 소음은 이번 시도를 다시 하라는
 * 이야기지 지금 재는 값을 보라는 이야기가 아니라, 뒤에 타이머와 그래프가 계속
 * 도는 채로 덮으면 "저 값은 살아 있나"가 화면에 남는다.
 *
 * 나가는 문은 시안대로 두 개다 — 헤더의 `×`(진단 자체를 그만둔다)와 `다시 측정하기`.
 * 조용한 데로 옮겨서 다시 재는 것이 이 화면이 권하는 길이라 그쪽이 큰 버튼이다.
 */
export const NoisyRoomView = ({ onRetry }: { onRetry: () => void }) => {
  const { t } = useTranslation();

  return (
    <FullScreenNotice
      title={t('web.diagnosis.noisyRoom.title')}
      // 배너는 경고가 아니라 처방이다 — 시안도 사각 경고 배너가 아니라 분홍 알약을 쓴다.
      banner={t('web.diagnosis.noisyRoom.banner')}
      footer={
        <button
          type="button"
          onClick={onRetry}
          className="flex h-[50px] w-full items-center justify-center gap-2 rounded-full border-2 border-[hsl(var(--field-border))] text-base font-bold tracking-[0.08px] text-[var(--bk-900)] motion-safe:active:scale-95"
        >
          <RotateCwIcon className="h-4 w-4" aria-hidden="true" />
          {t('web.diagnosis.noisyRoom.retry')}
        </button>
      }
    />
  );
};
